import React, {useRef, useState} from 'react';
import clsx from "clsx";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from '@mui/icons-material/Close';
import CircularProgress from '@mui/material/CircularProgress';
import {makeStyles} from "@mui/styles";

const useStyles = makeStyles((theme) => ({
    logoImage: {
        cursor: 'pointer',
        display: 'inline-block',
        maxWidth: '100%',
        height: 'auto',
        padding: 0
    },
    imageUploader: {
        margin: '12px 0',

        '& .delete-logo': {
            display: 'none',
            padding: 4,
            lineHeight: 1,
            fontSize: '1rem'
        },

        '&:hover .delete-logo': {
            display: 'block'
        }

    },
    uploadButton: {
        display: 'inline-block',
        backgroundColor: 'transparent',
        height: 64,
        width: '100%',
        marginTop: 32,
        borderRadius: 0,

        '&:hover':{
            backgroundColor: 'transparent !important',
        },

        '& > span.uploadButtonText': {
            backgroundColor: '#f5f5f5',
            padding: '5px 12px',
            color: '#555555',
            display: 'inline-block',
            position: 'absolute',
            top: 16,
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 2,
            borderRadius: 5,
            whiteSpace: 'nowrap',
        },

        '&::before, &::after': {
            content: '""',
            borderBottom: '2px dashed #e0e0e0',
            display: 'inline-block',
            height: '1px',
            marginTop: 25,
            position: 'absolute',
            verticalAlign: 'middle',
            width: '50%',
            zIndex: 0
        },

        '&::before': {
            left: 0,
        },

        '&::after': {
            right: 0,
        }

    }
}));

export default function ImageUploader(props) {

    const classes = useStyles(props);

    const {logo, logoParameters, updateLogoData, openConfigurator, screenShooting} = props;

    const logoRef = useRef(null);

    const [formValues, setFormValues] = useState({
        formLogo: {
            image: logo,
            filename: logoParameters.filename,
            width: logoParameters.width,
            height: logoParameters.height,
            alignment: logoParameters.alignment,
        }
    });

    const [sending, setSending] = useState(false);

    const handleInputChange = (data) => {

        setFormValues({...formValues, ['formLogo']: data});

        setTimeout(function (){

            if(logoRef.current){

                data.width = logoRef.current.width;
                data.height = logoRef.current.height;

            }

            updateLogoData(data);

        });

    };

    return <div className={classes.imageUploader}>

        {(formValues.formLogo.image && formValues.formLogo.image !== '') ?
            <div className={clsx('logo-wrapper', `logo-alignment-${formValues.formLogo.alignment}`)}>

                <img ref={logoRef}
                     alt="logo"
                     className={classes.logoImage}
                     onClick={(e) => {
                         openConfigurator(e);
                     }}
                     src={formValues.formLogo.image} />

                <IconButton
                    className="delete-logo"
                    sx={{position: 'absolute', right: 0, top: 0}}
                    aria-label="delete"
                    onClick={() => {
                        handleInputChange({
                            image: null,
                            filename: '',
                            width: null,
                            height: null,
                            alignment: 'center',
                        });
                    }}>
                    <CloseIcon />
                </IconButton>

            </div> :

            <Button className={classes.uploadButton}
                    style={{display: screenShooting ? 'none' : 'block'}}
                    disabled={false}
                    size="large"
                    variant="text"
                    component="label"
                    fullWidth>
                {sending ? <CircularProgress color="inherit" /> : <span className="uploadButtonText">Add your logo (1MB max)</span>}

                <input
                    type="file"
                    onChange={async e => {

                        function readFileAsync() {

                            return new Promise((resolve, reject) => {

                                const file = e.target.files[0];

                                if (!file || file.length === 0) {

                                    alert('The file is corrupted or selected incorrectly, please try again!')

                                    return;

                                } else {

                                    setSending(true);

                                }

                                // 1. Check file type
                                const fileExt = file.name.split('.').pop().toLowerCase();
                                const imageTypes = ["jpg", "jpeg", "gif", "png"];

                                if (!imageTypes.includes(fileExt)) {
                                    alert('Sorry, this file format not supported!');
                                    setSending(false);
                                    return;
                                }

                                // 2. Check file size
                                const size = file.size;

                                if (imageTypes.includes(fileExt)) {
                                    if (size > 1048576) {
                                        alert('Sorry, for images 1MB max.!');
                                        setSending(false);
                                        return;
                                    }
                                }

                                const fileReader = new FileReader()
                                fileReader.readAsDataURL(file);

                                fileReader.onload = () => {

                                    const logoData = {
                                        image: fileReader.result,
                                        filename: file.name,
                                        width: null,
                                        height: null,
                                        alignment: 'center',
                                    }

                                    handleInputChange(logoData);

                                    setSending(false);

                                };

                                fileReader.onerror = error => {

                                    console.log("Upload Image Error: ", error);

                                    setSending(false);

                                };

                            });

                        }

                        await readFileAsync();

                    }}
                    hidden
                />
            </Button>

        }

    </div>

}